import { useApi, useTranslation } from '@zurich/common/hooks';
import { postVSGAGutachtenPublic } from '~/lib/api';

export function usePostVSGAData() {
  const { t } = useTranslation();

  return useApi({
    request: postVSGAGutachtenPublic,
    options: {
      errorText: t('vsga:postVSGAEndPoint.error'),
      successText: t('vsga:postVSGAEndPoint.success'),
    },
  });
}
